import React, { useRef } from "react";
import classes from "./ResgisterModal.module.css";
import { Button, Form, Modal } from "antd";
import useDeviceWidth from "components/UseDeviceWidth";
import { useDispatch, useSelector } from "react-redux";
import { modalActions } from "store-redux/modal-slice";
import RegisterForm from "../RegisterForm";

function CustomerRegisterModal({ isModalOpen, setIsModalOpen }) {
  const width = useDeviceWidth();
  const { modalIsVisible, modalType } = useSelector((state) => state.modal);
  const dispatch = useDispatch();
  const childFormRef = useRef();

  // Open Modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // Close Modal
  const handleCancel = () => {
    // setIsModalOpen(false)
    dispatch(modalActions.toggleModal());
    childFormRef.current?.resetForm();

  };

  // Submit Form
  const handleOk = async () => {
    try {
    } catch (errorInfo) {
      console.error("Validation Failed:", errorInfo); // Log validation errors
    }
  };

  console.log('modal is visible ?', modalIsVisible, modalType)

  return (
    <div className={classes.outer}>
      <Modal
        open={modalIsVisible && modalType === "customerSignup"}
        onOk={handleOk} // Submit button click
        onCancel={handleCancel} // Cancel button click
        okText="Submit" // Text for OK button
        cancelText="Cancel" // Text for Cancel button
        footer={null}
        className="login-modal"
        width={width > 1000 ? 640 : width > 650 ? 584 : "80%"}
        centered
      >
        <div className={classes.loginOuter}>
          <RegisterForm
            isLoginOpen={isModalOpen}
            setIsLoginOpen={setIsModalOpen}
            ref={childFormRef}
          />
        </div>
      </Modal>
    </div>
  );
}

export default CustomerRegisterModal;
